import { formatDate, formatGeneral, unformatCreditCard } from 'cleave-zen';
import { AxiosError } from 'axios';

export type CreditCard = {
  cardCode: string;
  cardExpiration: string;
  cardNumber: string;
  isDefault?: boolean;
};

export function formatCreditCardNumber(value: string): string {
  return formatGeneral(value, {
    delimiterLazyShow: true,
    numericOnly: true,
    blocks: [4, 4, 4, 4, 3],
    delimiters: [' ', ' ', ' ', ' '],
  });
}

export function unformatCreditCardNumber(value: string): string {
  return unformatCreditCard(value);
}

export function formatExpirationNumber(value: string): string {
  return formatDate(value, {
    datePattern: ['m', 'y'],
    delimiter: '/',
    delimiterLazyShow: true,
  });
}

export type CardErrorsByField = {
  general: string[];
  cardNumber: string[];
  cardExpiration: string[];
  cardCode: string[];
};

export const emptyCardErrors: CardErrorsByField = {
  general: [],
  cardCode: [],
  cardExpiration: [],
  cardNumber: [],
};

type PaymentErrorResponseData = {
  data?: {
    attemptSummary?: {
      toDateTime?: string;
      remainingAttemptCount?: number;
    };
    paymentErrorCode?: string;
    paymentErrorMessage?: string;
  };
  errorCode?: string;
};

export function isAxiosError(error: unknown): error is AxiosError {
  return (
    'name' in (error as AxiosError) &&
    (error as AxiosError).name == 'AxiosError'
  );
}

export function isPaymentError(
  error: unknown,
): error is AxiosError<PaymentErrorResponseData> {
  return (
    isAxiosError(error) &&
    (error.response?.data as PaymentErrorResponseData)?.errorCode ===
      'PaymentError'
  );
}
